export default function getColorByColumn(col: string): string {
  switch (col) {
    case 'clicks':
    case 'uniqueClicks':
    case 'revenue':
      return '#42FF00' // '#2FB2FF'
    case 'registrationCount':
      return '#6944FF' // '#FF8C00'
    case 'registrations':
      return '#44bacf'
    case 'firstDepositCount':
      return '#A8B41D'
    case 'conversions':
      return '#7545e6'
    case 'firstDepositSum':
      return '#321c5c'
    case 'approvedLeads':
      return '#00E396'
    case 'holdLeads':
      return '#858585'
    case 'trashLeads':
      return '#000'
    case 'rejectedLeads':
      return '#e60b0b'
    case 'cr':
      return '#5e490d'
    case 'epc':
      return '#faaf16'
    case 'crReg':
      return '#134722'
    case 'crFtd':
      return '#1a0afc'
    case 'crFtdReg':
      return '#fc0a8b'
    case 'approvedPercent':
      return '#61a8c9'
    case 'approvedSum':
      return '#60cf44'
    case 'holdSum':
      return '#6e6867'
    case 'rejectedSum':
      return '#ba5343'
    case 'revShareRevenueSum':
    default:
      return '#000'
  }
}

export function getColorForScale(color: string, column: string) {
  switch (column) {
    case 'clicks':
    case 'uniqueClicks':
      return '#42FF00'
    case 'registrationCount':
      return '#6944FF'
    case 'firstDepositCount':
      return '#A8B41D'
    default:
      return color
  }
}
